import { useMemo } from 'react';

import { EmbeddedMessage, WhatsApp } from 'constants/messageMediums';
import { AllMessageMedium } from 'modules/domains/campaign/types';
import { MessageMedium } from 'modules/graphql/types';
import { EditEmailContext } from 'modules/templateEditor/EditEmail/context/EditMailContext';
import { EmbeddedContext } from 'modules/templateEditor/EditEmbedded/context/EmbeddedContext';
import { InAppContext } from 'modules/templateEditor/EditInApp/context/InAppContext';
import { PushContext } from 'modules/templateEditor/EditPush/context/PushContext';
import { SMSContext } from 'modules/templateEditor/EditSMS/context/SMSContext';
import { WebPushContext } from 'modules/templateEditor/EditWebPush/context/WebPushContext';
import { WhatsAppContext } from 'modules/templateEditor/EditWhatsApp/context/WhatsAppContext';

type TemplateMediumContextMapper = {
  [key in AllMessageMedium]?: any; // fix me
};

const TEMPLATE_MEDIUM_CONTEXT_MAPPER: TemplateMediumContextMapper = {
  [MessageMedium.SMS]: SMSContext,
  [MessageMedium.Email]: EditEmailContext,
  [MessageMedium.Push]: PushContext,
  [MessageMedium.WebPush]: WebPushContext,
  [MessageMedium.InApp]: InAppContext,
  [EmbeddedMessage]: EmbeddedContext,
  [WhatsApp]: WhatsAppContext,
};

export const getContext = (medium: AllMessageMedium) => {
  return TEMPLATE_MEDIUM_CONTEXT_MAPPER?.[medium];
};

export const useEditorContext = ({ messageMedium }: { messageMedium: AllMessageMedium }) => {
  const context = useMemo(() => getContext(messageMedium), [messageMedium]);
  return context;
};
